import MediaContainer from './MediaContainer';

export default MediaContainer;
